var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7799 67.5365C45.1543 67.5365 46.5286 67.7329 47.7066 68.1255L26.5024 8.04681L24.539 2.15673C23.95 0.389712 22.183 -0.395631 20.6123 0.193377L2.15673 6.27979C0.389712 6.86879 -0.395631 8.63581 0.193377 10.2065L2.15673 16.0966C2.74574 17.8636 4.51276 18.6489 6.08345 18.0599L15.7039 14.9186L35.1411 70.0889C37.6935 68.5182 40.6385 67.5365 43.7799 67.5365Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9607 53.2042L57.5235 60.076C55.5601 60.8613 53.2041 59.6833 52.6151 57.72L45.7433 38.2827C44.958 36.3194 46.136 33.9633 48.0993 33.3743L67.5366 26.5026C69.4999 25.7172 71.856 26.8953 72.445 28.8586L79.3167 48.2959C80.1021 50.2592 78.924 52.4189 76.9607 53.2042Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5051 21.2013L45.3507 25.717C43.3873 26.5024 41.0313 25.3243 40.4423 23.361L35.9265 10.2065C35.1412 8.24313 36.3192 5.8871 38.2826 5.29809L51.4371 0.782371C53.4004 -0.00297219 55.7564 1.17504 56.3455 3.1384L60.8612 16.2929C61.6465 18.0599 60.6648 20.4159 58.5051 21.2013Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0418 65.5733L92.0785 59.6832C91.4895 57.9162 89.7224 57.1309 88.1517 57.7199L52.4186 70.089C56.149 72.445 58.7014 76.3718 59.4867 80.8875L92.2748 69.6963C93.8455 69.1073 94.6308 67.3403 94.0418 65.5733Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7799 72.6414C37.8898 72.6414 32.9814 77.5498 32.9814 83.4398C32.9814 89.3299 37.8898 94.2383 43.7799 94.2383C49.6699 94.2383 54.5783 89.3299 54.5783 83.4398C54.5783 77.3534 49.6699 72.6414 43.7799 72.6414Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.35f4561604343a19f9d8aa383c5b79b5.svg";
export { ForwardRef as ReactComponent };